import { Base } from "ui/Scripts/source/framework/base";
import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ITaskHandler, TaskHandler } from "./taskHandler";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";

export interface ITaskEditItem {
    id: string;
    companyId: string;
    taskTypeId: string;
    taskStateId: string;
    taskPriorityId: string;
    unitId: string;
    code: string;
    name: string;
    createDate: number;
    createUserCode: string;
    createUserName: string;
    createUserPicture: string;
    modifyDate: number;
    modifyUserCode: string;
    modifyUserName: string;
    modifyUserPicture: string;
    deleteDate: number;
    deleteUserCode: string;
    deleteUserName: string;
    deleteUserPicture: string;
    lockedDate: number;
    lockedUserCode: string;
    lockedUserName: string;
    lockedUserPicture: string;
    taskRepetitionType: number;
    rowId: string;
    taskHeaderDataCols: ITaskDataRowCol[];
    taskDataRows: ITaskDataRow[];
    taskHandlers: ITaskHandler[];

    isNew(): boolean;
}

export class TaskEditItem implements ITaskEditItem {
    id: string;
    companyId: string;
    taskTypeId: string;
    taskStateId: string;
    taskPriorityId: string;
    unitId: string;
    code: string;
    name: string;
    createDate: number;
    createUserCode: string;
    createUserName: string;
    createUserPicture: string;
    modifyDate: number;
    modifyUserCode: string;
    modifyUserName: string;
    modifyUserPicture: string;
    deleteDate: number;
    deleteUserCode: string;
    deleteUserName: string;
    deleteUserPicture: string;
    lockedDate: number;
    lockedUserCode: string;
    lockedUserName: string;
    lockedUserPicture: string;
    taskRepetitionType: number;
    rowId: string;
    taskHeaderDataCols: TaskDataRowCol[];
    taskDataRows: TaskDataRow[];
    taskHandlers: TaskHandler[];

    constructor();
    constructor(obj: ITaskEditItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.taskTypeId = obj && obj.taskTypeId || "";
        this.taskStateId = obj && obj.taskStateId || "";
        this.taskPriorityId = obj && obj.taskPriorityId || "";
        this.unitId = obj && obj.unitId || "";
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.createDate = obj && obj.createDate || 0;
        this.createUserCode = obj && obj.createUserCode || "";
        this.createUserName = obj && obj.createUserName || "";
        this.createUserPicture = obj && obj.createUserPicture || "";
        this.modifyDate = obj && obj.modifyDate || 0;
        this.modifyUserCode = obj && obj.modifyUserCode || "";
        this.modifyUserName = obj && obj.modifyUserName || "";
        this.modifyUserPicture = obj && obj.modifyUserPicture || "";
        this.deleteDate = obj && obj.deleteDate || null;
        this.deleteUserCode = obj && obj.deleteUserCode || "";
        this.deleteUserName = obj && obj.deleteUserName || "";
        this.deleteUserPicture = obj && obj.deleteUserPicture || "";
        this.lockedDate = obj && obj.lockedDate || null;
        this.lockedUserCode = obj && obj.lockedUserCode || "";
        this.lockedUserName = obj && obj.lockedUserName || "";
        this.lockedUserPicture = obj && obj.lockedUserPicture || "";
        this.taskRepetitionType = obj && obj.taskRepetitionType || 0;
        this.rowId = obj && obj.rowId || "";
        this.taskHeaderDataCols = Base.getTypedArray<TaskDataRowCol>(obj ? obj.taskHeaderDataCols : null, TaskDataRowCol);
        this.taskDataRows = Base.getTypedArray<TaskDataRow>(obj ? obj.taskDataRows : null, TaskDataRow);
        this.taskHandlers = Base.getTypedArray<TaskHandler>(obj ? obj.taskHandlers : null, TaskHandler);
        TaskHandler.sortTaskHandlers(this.taskHandlers);
    }

    isNew(): boolean {
        return Base.isNullOrEmpty(this.rowId);
    }

    initializeTaskDataRows(taskType: ITaskEditTypeItem) {
        for (let i = 0; i < this.taskDataRows.length; i++) {
            this.taskDataRows[i].initializeCols(taskType);
        }
    }
}